// 求职类型常量 - 统一使用数字值：0-社招，1-校招，2-实习
export const JOB_TYPES = [
  { label: '社招', value: "0" },
  { label: '校招', value: "1" },
  { label: '实习', value: "2" }
]

// 获取求职类型标签
export const getJobTypeLabel = (value) => {
  const jobType = JOB_TYPES.find(type => type.value === value)
  return jobType ? jobType.label : ''
}

// 获取求职类型对象
export const getJobType = (value) => {
  return JOB_TYPES.find(type => type.value === value)
}

// 岗位类型常量
export const JOB_POSITIONS = [
  { label: '产品经理', value: 'product_manager' },
  { label: '前端开发工程师', value: 'frontend_developer' },
  { label: '后端开发工程师', value: 'backend_developer' },
  { label: '全栈开发工程师', value: 'fullstack_developer' },
  { label: 'UI设计师', value: 'ui_designer' },
  { label: 'UX设计师', value: 'ux_designer' },
  { label: '数据分析师', value: 'data_analyst' },
  { label: '运营专员', value: 'operation_specialist' },
  { label: '市场专员', value: 'marketing_specialist' },
  { label: '销售代表', value: 'sales_representative' },
  { label: '人力资源', value: 'hr' },
  { label: '财务专员', value: 'finance_specialist' },
  { label: '测试工程师', value: 'test_engineer' },
  { label: '运维工程师', value: 'devops_engineer' },
  { label: '算法工程师', value: 'algorithm_engineer' },
  { label: '项目经理', value: 'project_manager' },
  { label: '商务拓展', value: 'business_development' },
  { label: '内容运营', value: 'content_operation' },
  { label: '新媒体运营', value: 'new_media_operation' },
  { label: '客服专员', value: 'customer_service' }
]

// 获取岗位标签
export const getJobPositionLabel = (value) => {
  const position = JOB_POSITIONS.find(pos => pos.value === value)
  return position ? position.label : ''
}

// 获取岗位对象
export const getJobPosition = (value) => {
  return JOB_POSITIONS.find(pos => pos.value === value)
}

// 学历选项常量
export const EDUCATION_OPTIONS = [
  { value: 3, label: '大专及以上' },
  { value: 4, label: '本科及以上' },
  { value: 5, label: '硕士及以上' },
  { value: 6, label: '博士' }
]

// 工作性质选项常量
export const WORK_NATURE_OPTIONS = [
  { key: 'social', label: '社招', value: '0' },
  { key: 'campus', label: '校招', value: '1' },
  { key: 'intern', label: '实习', value: '2' }
]

export const RECRUITMENT_TYPES = [
  { label: '社招', value: "0" },
  { label: '校招', value: "1" },
  { label: '实习', value: "2" }
]

export const getRecuitmenntLabel = (value) => {
  const option = RECRUITMENT_TYPES.find(opt => opt.value == value)
  return option ? option.label : '校招'
}

// 根据值获取学历标签
export const getEducationLabel = (value) => {
  const option = EDUCATION_OPTIONS.find(opt => opt.value === value)
  return option ? option.label : '不限'
}

// 根据值获取工作性质标签
export const getWorkNatureLabel = (value) => {
  const option = WORK_NATURE_OPTIONS.find(opt => opt.value === value)
  return option ? option.label : '不限'
}

// 发布时间选项常量
export const PUBLISH_DAYS_OPTIONS = [
  { value: 0, label: '发布时间:不限' },
  { value: 1, label: '1天内' },
  { value: 3, label: '3天内' },
  { value: 7, label: '7天内' },
  { value: 15, label: '15天内' },
  { value: 30, label: '30天内' }
]

// 根据值获取发布时间标签
export const getPublishDaysLabel = (value) => {
  const option = PUBLISH_DAYS_OPTIONS.find(opt => opt.value === value)
  return option ? option.label : '不限'
}

// 薪资展示：start/end 均有且 start 不包含“天”则展示 K 区间，否则仅展示 start；都无则“面议”
export const formatSalary = (start, end, month) => {
  const s = start != null ? String(start) : ''
  const e = end != null ? String(end) : ''
  const m = month != null && month !== '' ? String(month) : ''
  if (s && e && !s.includes('天')) {
    return `${s}K-${e}K/月${m ? ` * ${m}月` : ''}`
  } else if (s) {
    return s
  }
  return null
}
